/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'location': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M512 656c-51.2 0-99.2-19.2-136-56-75.2-75.2-75.2-196.8 0-272 36.8-36.8 84.8-56 136-56s99.2 19.2 136 56c75.2 75.2 75.2 196.8 0 272-36.8 36.8-84.8 56-136 56zm0-320c-33.6 0-65.6 12.8-91.2 36.8-49.6 49.6-49.6 131.2 0 180.8 24 24 56 36.8 91.2 36.8s65.6-12.8 91.2-36.8 36.8-56 36.8-89.6-12.8-65.6-36.8-91.2c-25.6-24-57.6-36.8-91.2-36.8z"/><path pid="1" d="M512 992c-4.8 0-9.6-1.6-14.4-3.2C481.6 980.8 112 784 112 464c0-220.8 179.2-400 400-400s400 179.2 400 400c0 320-369.6 516.8-385.6 524.8-4.8 1.6-9.6 3.2-14.4 3.2zm0-864c-185.6 0-336 150.4-336 336 0 248 268.8 420.8 336 459.2C579.2 884.8 848 712 848 464c0-185.6-150.4-336-336-336z"/>'
  }
})
